<template>
  <div class="p-3 bg-secondary-3 rounded">
    <validation-observer ref="addForm" novalidate>
      <div class="my-3">
        <label class="data-name">Asunto:</label>
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            v-model="model.subject"
            custom-error-msg="El Asunto es requerido"
            :error="errors[0]"
            placeholder="Escriba el asunto..."
          />
        </validation-provider>
      </div>
      <div class="my-3">
        <label class="data-name">Comentario de Bitácora:</label>
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="model.comment"
            :error="errors[0]"
            custom-error-msg="El Comentario de Bitácora es requerido"
            :count-classes="['d-block', 'small-counter', 'text-right']"
            :maxlength="3000"
            show-char-count
            placeholder="Escriba el comentario de bitácora..."
          />
        </validation-provider>
      </div>
      <div class="d-flex justify-content-end my-3">
        <action-button
          class="mr-3"
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger"
          @click="cancel"
        />
        <action-button
          i="fas fa-plus"
          text="Añadir"
          variant="success"
          @click="save"
        />
      </div>
    </validation-observer>
  </div>
</template>

<script>
//mixins
import alertMixin from '@/mixin/alert.mixin.js';

//components
import ActionButton from 'ActionButton';
import CustomTextArea from 'CustomTextArea';
import CustomInput from 'CustomInput';

export default {
  name: 'BinnacleTabAdd',
  mixins: [alertMixin],
  components: {
    ActionButton,
    CustomTextArea,
    CustomInput,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async save() {
      const valid = await this.$refs.addForm.validate();
      if (!valid) return;
      this.$emit('save', this.model, this.$refs.addForm.reset);
    },
    cancel() {
      this.$emit('cancel', this.$refs.addForm.reset);
    },
  },
};
</script>

<style scoped></style>
